/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MeetingNoteRequest,
  MeetingNoteResponse,
} from '../models/index';
import {
    MeetingNoteRequestFromJSON,
    MeetingNoteRequestToJSON,
    MeetingNoteResponseFromJSON,
    MeetingNoteResponseToJSON,
} from '../models/index';

export interface CreateMyNoteRequest {
    meetingId: string;
    body: string;
}

export interface CreateNoteRequest {
    meetingId: string;
    meetingNoteRequest: MeetingNoteRequest;
}

export interface DeleteMyNodeRequest {
    meetingId: string;
}

export interface DeleteNodeRequest {
    meetingId: string;
    userId: string;
}

export interface GetMyNoteRequest {
    meetingId: string;
}

export interface GetNoteRequest {
    meetingId: string;
    userId: string;
}

export interface UpdateMyNoteRequest {
    meetingId: string;
    meetingNoteRequest: MeetingNoteRequest;
}

export interface UpdateNoteRequest {
    meetingId: string;
    userId: string;
    meetingNoteRequest: MeetingNoteRequest;
}

/**
 * 
 */
export class MeetingNoteControllerApi extends runtime.BaseAPI {

    /**
     * Create new meeting note for requester
     */
    async createMyNoteRaw(requestParameters: CreateMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling createMyNote().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createMyNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Create new meeting note for requester
     */
    async createMyNote(requestParameters: CreateMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse>> {
        const response = await this.createMyNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new meeting note
     */
    async createNoteRaw(requestParameters: CreateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling createNote().'
            );
        }

        if (requestParameters['meetingNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'meetingNoteRequest',
                'Required parameter "meetingNoteRequest" was null or undefined when calling createNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/note/new`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeetingNoteRequestToJSON(requestParameters['meetingNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Create new meeting note
     */
    async createNote(requestParameters: CreateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse>> {
        const response = await this.createNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete meeting note for requester
     */
    async deleteMyNodeRaw(requestParameters: DeleteMyNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling deleteMyNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete meeting note for requester
     */
    async deleteMyNode(requestParameters: DeleteMyNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.deleteMyNodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete meeting note
     */
    async deleteNodeRaw(requestParameters: DeleteNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling deleteNode().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deleteNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/user/{userId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete meeting note
     */
    async deleteNode(requestParameters: DeleteNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.deleteNodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get meeting note for requester
     */
    async getMyNoteRaw(requestParameters: GetMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling getMyNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Get meeting note for requester
     */
    async getMyNote(requestParameters: GetMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse> | null | undefined > {
        const response = await this.getMyNoteRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get meeting note
     */
    async getNoteRaw(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling getNote().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/user/{userId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Get meeting note
     */
    async getNote(requestParameters: GetNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse> | null | undefined > {
        const response = await this.getNoteRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Update meeting note for requester
     */
    async updateMyNoteRaw(requestParameters: UpdateMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling updateMyNote().'
            );
        }

        if (requestParameters['meetingNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'meetingNoteRequest',
                'Required parameter "meetingNoteRequest" was null or undefined when calling updateMyNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MeetingNoteRequestToJSON(requestParameters['meetingNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Update meeting note for requester
     */
    async updateMyNote(requestParameters: UpdateMyNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse>> {
        const response = await this.updateMyNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update meeting note
     */
    async updateNoteRaw(requestParameters: UpdateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeetingNoteResponse>>> {
        if (requestParameters['meetingId'] == null) {
            throw new runtime.RequiredError(
                'meetingId',
                'Required parameter "meetingId" was null or undefined when calling updateNote().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateNote().'
            );
        }

        if (requestParameters['meetingNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'meetingNoteRequest',
                'Required parameter "meetingNoteRequest" was null or undefined when calling updateNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/webmeet/meeting/{meetingId}/user/{userId}/note`.replace(`{${"meetingId"}}`, encodeURIComponent(String(requestParameters['meetingId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MeetingNoteRequestToJSON(requestParameters['meetingNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MeetingNoteResponseFromJSON));
    }

    /**
     * Update meeting note
     */
    async updateNote(requestParameters: UpdateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeetingNoteResponse>> {
        const response = await this.updateNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
